// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"2084":"9b0008ae","4316":"ad2866b8"}[chunkId] || chunkId) + "." + {"2084":"15bedcd87b76d44b","3318":"14f0f04152c25670","4316":"890f6f4190c9fdfb","6187":"2747a810426209ee"}[chunkId] + ".js";
};